import type { ServedQuestion } from "@patent-studio/api-types";

/** Where each question was asked, by its trigger, in the stages' order. */
export const ASKED_AT: readonly (readonly [string, string])[] = [
  ["invention_lock", "Invention"],
  ["novelty_run", "Novelty"],
  ["novelty_commit", "Novelty"],
  ["claim_lock", "Claim Strategy"],
];

const LABELS = new Map(ASKED_AT);

/** The stage that asked the question, as a card heads it; "Other" for a trigger no stage names. */
export function askedAt(question: ServedQuestion): string {
  return LABELS.get(question.trigger_point) ?? "Other";
}

/** Whether the question is still to be answered: asked and open, or put off for later. */
export function unresolved(question: ServedQuestion): boolean {
  return question.status === "open" || question.status === "parked";
}
